import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import WishListGql from '@/extensions/shop/store/graphql/queries/WishList.gql';
import WishListWithArticlePivotsGql from '@/extensions/shop/store/graphql/queries/WishListWithArticlePivots.gql';
// import WishListsGql from '@/extensions/shop/store/graphql/queries/WishLists.gql';
import WishListsPaginatedGql from '@/extensions/shop/store/graphql/queries/WishListsPaginated.gql';
import WishListArticlesPaginatedGql from '@/extensions/shop/store/graphql/queries/WishListArticlesPaginated.gql';
import SaveWishListGql from '@/extensions/shop/store/graphql/mutations/SaveWishList.gql';
// import CreateWishListGql from '@/extensions/shop/store/graphql/mutations/CreateWishList.gql';
// import UpdateWishListGql from '@/extensions/shop/store/graphql/mutations/UpdateWishList.gql';
// import DeleteWishListGql from '@/extensions/shop/store/graphql/mutations/DeleteWishList.gql';
import ValidateImportCsvGql from '@/extensions/shop/store/graphql/mutations/ValidateWishListImportCsv.gql';
import InitializeImport from '@/extensions/shop/store/graphql/mutations/InitializeWishListImport.gql';
import ProcessWishListArticlePaginationBulkActionGql from '@/extensions/shop/store/graphql/mutations/ProcessWishListArticlePaginationBulkAction.gql';

export default {
    initializeImport: (shop, file = null) =>
        new Promise((resolve, reject) => {
            if (file) file = _.removeDeepByKey(file, '__typename');
            apolloClient
                .mutate({
                    mutation: InitializeImport,
                    variables: {
                        shop: parseInt(shop),
                        file
                    }
                    // fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.CO_InitializeWishListImport))
                .catch(err => reject(err));
        }),
    validateImportCsv: (shop, file) =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: ValidateImportCsvGql,
                    variables: {
                        shop: parseInt(shop),
                        file: _.removeDeepByKey(file, '__typename')
                    }
                    // fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.CO_ValidateWishListImportCsv))
                .catch(err => reject(err));
        }),

    fetchWishListsPaginated: data =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: WishListsPaginatedGql,
                    variables: {
                        // Multistore: the store the admin UI currently has selected; the list
                        // shows its records by default and the store filter widens it again.
                        cms: _.get(data, 'cms') ? parseInt(_.get(data, 'cms')) : null,
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'updated_at'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        link: _.get(data, 'link.route', '/sales/order/'),
                        filters
                    }
                })
                // .then(({ data }) => resolve(data.CO_WishListsPaginated))
                .then(({ data }) => resolve(data.CO_WishListsPaginated))
                .catch(err => reject(err));
        }),
    fetchWishListArticlesPaginated: (data, wishList) =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: WishListArticlesPaginatedGql,
                    variables: {
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'updated_at'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        // link: _.get(data, 'link.route', '/wish-list/article/'),
                        filters,

                        // custom
                        wishList
                    }
                })
                .then(({ data }) => resolve(data.CO_WishListArticlesPaginated))
                .catch(err => reject(err));
        }),
    // Which store the record belongs to - all a refused detail page needs to
    // explain itself and offer the switch.

    fetchWishList: (id, cmsID = null) => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            let variables = { id: parseInt(id) };
            // Multistore: the record belongs to one store, so it is opened in that
            // store's context - the API refuses it from another one.
            if (cmsID) variables.cms = parseInt(cmsID);

            apolloClient
                .query({
                    query: WishListGql,
                    fetchPolicy: 'no-cache',
                    variables
                })
                .then(({ data }) => resolve(data.CO_WishList))
                .catch(err => reject(err));
        });
    },
    fetchWishListWithArticlePivots: id => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            let variables = { id: parseInt(id) };

            apolloClient
                .query({
                    query: WishListWithArticlePivotsGql,
                    fetchPolicy: 'no-cache',
                    variables
                })
                .then(({ data }) => resolve(data.CO_WishList))
                .catch(err => reject(err));
        });
    },
    //     if (wishList === undefined) throw new Error('required argument is missing');
    //
    //     wishList = _.removeDeepByKey(wishList, '__typename');
    //     return new Promise((resolve, reject) => {
    //         apolloClient
    //             .mutate({
    //                 mutation: CreateWishListGql,
    //                 variables: { wishList }
    //             })
    //             .then(({ data }) => {
    //                 apolloClient.clearStore();
    //                 resolve(data.CO_CreateWishList);
    //             })
    //             .catch(err => reject(err));
    //     });
    // },
    save: wishList => {
        if (wishList === undefined) throw new Error('required argument is missing');

        wishList = _.removeDeepByKey(wishList, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: SaveWishListGql,
                    variables: { wishList }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_SaveWishList);
                })
                .catch(err => reject(err));
        });
    },
    processWishListArticlePaginationBulkAction: (action, data, wishListId) => {
        return new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .mutate({
                    mutation: ProcessWishListArticlePaginationBulkActionGql,
                    variables: {
                        action,
                        filters,
                        selection: {
                            type: _.get(data, 'pageInfo.selection.type', 'inclusive'),
                            identifiers: _.get(data, 'pageInfo.selection.identifiers', []),
                        },
                        order: _.get(data, 'variables.order', 'id'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        wishList: parseInt(wishListId),
                    },
                })
                .then(({ data }) => resolve(data.CO_ProcessWishListArticlePaginationBulkAction))
                .catch(err => reject(err));
        });
    },
    // delete: id => {
    //     if (id === undefined) throw new Error('required argument is missing');
    //
    //     return new Promise((resolve, reject) => {
    //         apolloClient
    //             .mutate({
    //                 mutation: DeleteWishListGql,
    //                 variables: { id }
    //             })
    //             .then(({ data }) => {
    //                 apolloClient.clearStore();
    //                 resolve(data.CO_DeleteWishList);
    //             })
    //             .catch(err => reject(err));
    //     });
    // }
};
